import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";

@Component({
  selector: "kreform-field-ion-editor",
  template: `
    <ng-container>
      <ion-item>Editor 暂不支持</ion-item>
    </ng-container>
  `,
})
export class KreFormFieldIonEditor extends FieldType {}
